
define('text!core/controllers/Error-403.html',[],function () { return '<section class="page pagePadded">\n\t<header class="pageHeader">\n\t\t<h1 class="pageTitle">{{\'core.forbidden.title\'|i18n}}</h1>\n\t</header>\n    <div class="conSecond">\n    \t<p class="dnaTextCenter" data-ng-controller="ErrorController">{{\'core.forbidden\'|i18n}}</p>\n    </div>\n</section>\n';});

